// Utility function to retrieve a single feature treatment
export const retrieveFeatureTreatment = async (
  baseUrl: string,
  splitName: string,
): Promise<string> => {
  const url = `${baseUrl}/v7/featuretreatments/treatment/${splitName}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data.treatment;
  } catch (error) {
    console.error(`Failed to fetch treatment for ${splitName}:`, error);
    return 'control'; // Return default/control value
  }
};
